import { Component, Input, Output, EventEmitter } from '@angular/core';

export type ButtonVariant = 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger';
export type ButtonSize = 'sm' | 'md' | 'lg';

@Component({
  selector: 'app-button',
  standalone: false,
  templateUrl: './button.component.html'
})
export class ButtonComponent {
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() variant: ButtonVariant = 'primary';
  @Input() size: ButtonSize = 'md';
  @Input() disabled = false;
  @Input() loading = false;
  @Input() icon?: string;
  @Input() fullWidth = false;

  @Output() clicked = new EventEmitter<Event>();

  get hasContent(): boolean {
    return true; // Simple check for ng-content
  }

  getClasses(): string {
    let base = 'inline-flex items-center justify-center font-medium rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2';

    // Size
    const sizes = {
      sm: 'px-3 py-1.5 text-sm',
      md: 'px-4 py-2 text-sm',
      lg: 'px-6 py-3 text-base'
    };
    base += ` ${sizes[this.size]}`;

    // Width
    if (this.fullWidth) base += ' w-full';

    // Variants
    const variants = {
      primary: 'bg-primary text-white hover:bg-slate-800 disabled:opacity-50 disabled:bg-slate-600 focus:ring-primary',
      secondary: 'bg-secondary text-white hover:bg-blue-600 disabled:opacity-50 focus:ring-secondary',
      outline: 'border border-slate-300 bg-white text-slate-700 hover:bg-slate-50 disabled:opacity-50',
      ghost: 'text-slate-600 hover:bg-slate-100 hover:text-slate-900 disabled:opacity-50',
      danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500 disabled:opacity-50'
    };
    base += ` ${variants[this.variant]}`;

    if (this.disabled || this.loading) {
      base += ' cursor-not-allowed opacity-70';
    }

    return base;
  }

  onClick(event: Event) {
    if (!this.disabled && !this.loading) {
      this.clicked.emit(event);
    }
  }
}
